import { FC } from 'react';

import noop from 'lodash/noop';
import Divider from '../Divider';

import './styles.scss';

interface Props {
  onClick?: () => void;
  name: string;
  count: number | string;
  icon: string;
  dividerColor: string;
  width?: number | string;
}

const Tile: FC<Props> = ({ name, count, dividerColor, icon, width = '100%', onClick = noop }) => {
  return (
    <div
      className="dm-tile d-flex-row justify-content-center align-items-center border-grey-06 bg-grey-08"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onClick();
        }
      }}
      style={{ width }}
    >
      <h6 className="dm-tile__count font-scale-24pt">{count}</h6>
      <Divider color={dividerColor} />
      <h6 className="dm-tile__name inter-ui-font-family font-scale-24pt">
        <i className={icon} /> {name}
      </h6>
    </div>
  );
};

export default Tile;
